import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-restore-pw',
  templateUrl: './restore-pw.component.html',
  styleUrls: ['./restore-pw.component.scss']
})
export class RestorePwComponent implements OnInit {

  oldPass: string = '';
  newPass: string = '';
  confPass: string = '';
  hayCambios: boolean = false;
  msgBoton: string;
  constructor(private userService: UserService, private router: Router) { }

  ngOnInit() {
  }

  updatePassword() {
    let req = {
      oldPassword: this.oldPass,
      newPassword: this.newPass,
      confirmPassword: this.confPass
    };
    this.userService.updatePassword(req)
      .subscribe(data => {
        Swal.fire({
          title: 'Cambio realizado correctamente',
          text: 'Deberá ingresar con las nuevas credenciales',
          icon: 'success',
          confirmButtonText: 'Entendido!'
        }).then((result) => {
          localStorage.clear();
          sessionStorage.clear();
          this.router.navigate(['']);
        });
      })
  }

  changeEvent(event, tipo) {
    switch (tipo) {
      case 'oldPw':
        this.oldPass = event;
        break;
      case 'newPw':
        this.newPass = event;
        break;
      case 'confPw':
        this.confPass = event;
        break;
    }
    if ((this.oldPass.length > 0) && (this.newPass.length > 0) && (this.newPass == this.confPass)) {
      this.hayCambios = true;
      this.msgBoton = 'Actualizar contraseña';
    } else {
      this.hayCambios = false;
      this.msgBoton = 'Las contraseñas no coinciden';
    }
  }

}
